import type { FC, ReactNode } from "react";
import { type SvgIconProps, Tooltip } from "@mui/material";
import type { TooltipProps } from "@mui/material/Tooltip";
import { InfoIcon, InfoOutlinedIcon } from "@ui-icons";

interface InfoTooltipProps extends Omit<TooltipProps, "children" | "slotProps"> {
  children: ReactNode;
  filled?: boolean;
  slotProps?: {
    Icon?: SvgIconProps;
  };
  size?: SvgIconProps["fontSize"];
}

const InfoTooltip: FC<Omit<InfoTooltipProps, "title">> = ({
  children,
  filled,
  slotProps,
  size = "medium",
  ...props
}) => {
  const Icon = filled ? InfoIcon : InfoOutlinedIcon;

  return children ? (
    <Tooltip arrow title={children} placement="top" disableInteractive {...props}>
      <Icon
        className="cursor-help opacity-50"
        data-test-id="tooltip-invoker"
        fontSize={size}
        {...slotProps?.Icon}
      />
    </Tooltip>
  ) : null;
};

export default InfoTooltip;
